import { Box, Stack } from "@mui/material";
import { Common, Custom } from "components";
import { useApp, useTheme } from "contexts";
import { Helpers } from "utils";

type Props = {
  open: boolean;
  title: string;
  headline: string;
  onClose: () => void;
};

export const Message = ({ open, title, headline, onClose }: Props) => {
  const { theme } = useTheme();
  const { t } = useApp();

  return (
    <Custom.Modal open={open} onClose={onClose} title={title}>
      <Box>
        <Stack spacing={theme.spacing.md}>
          <Custom.Typography
            align="center"
            size={theme.font.xs}
            weight={theme.font.bold}
          >
            {headline}
          </Custom.Typography>
        </Stack>
      </Box>

      <Box mt={theme.spacing.md} textAlign="center">
        <Common.Image
          sx={{ width: 115 }}
          src={Helpers.getImage("confirmation.png")}
        />
      </Box>

      <Custom.Button
        fullWidth
        variant="contained"
        sx={{ mt: theme.spacing.md }}
        onClick={onClose}
      >
        {t.action.close}
      </Custom.Button>
    </Custom.Modal>
  );
};
